<template>
  <base-section
    id="jobs"
  >
    <!-- <v-img
      :src="require('@/assets/logo.svg')"
      class="mx-auto mb-8"
      max-width="128"
    /> -->

    <base-section-heading title="Sección en Desarrollo">
      Estamos trabajando en el contenido de esta sección. Muy pronto estará operativa.
    </base-section-heading>

    <!-- <base-section-heading title="Últimos trabajos">
      Aquí puede ver una selección de algunos de nuestros últimos trabajos realizados.
    </base-section-heading> -->

    <v-container>
      <!-- <v-row
        align="center"
        justify="center"
      >
        <v-col
          v-for="(job, n) in items"
          :key="n"
          cols="12"
          md="3"
        >
          <base-hexagon-generator
            :img="job.image"
            :slug="job.slug"
            base-url="jobs"
          />
          <div class="text-center body-1 text-uppercase">
            {{ job.title }}
          </div>
        </v-col>
      </v-row> -->
      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="173.20508"
        height="200"
      >
        <defs>
          <mask
            id="mascara"
          >
            <path
              style="fill:#ffffff"
              d="m 173.66057,149.04362 -86.602541,50 -86.60254042,-50 4.4e-7,-100.000003 L 87.05803,-0.95638275 173.66057,49.043618 Z"
            />
          </mask>
        </defs>
        <g>
          <image
            y="0"
            x="0"
            :xlink:href="imagen"
            height="200"
            width="356"
            mask="url(#mascara)"
          />
        </g>
      </svg> -->
    </v-container>

    <!-- <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          md="7"
        >
          <v-simple-table>
            <thead>
              <tr>
                <th />
                <th class="body-1 font-weight-bold text-center">
                  What's in the Demo?
                </th>
                <th class="body-1 font-weight-bold text-center">
                  What's in the PRO version?
                </th>
              </tr>
            </thead>

            <tbody class="body-1">
              <tr
                v-for="([name, one, two], i) in features"
                :key="i"
              >
                <td v-text="name" />

                <td class="text-center font-weight-bold">
                  <template v-if="typeof one === 'boolean'">
                    <v-icon :color="one ? 'success' : 'error'">
                      mdi-{{ one ? 'check' : 'close' }}
                    </v-icon>
                  </template>

                  <template v-else>
                    {{ one }}
                  </template>
                </td>

                <td class="text-center font-weight-bold">
                  <template v-if="typeof two === 'boolean'">
                    <v-icon :color="two ? 'success' : 'error'">
                      mdi-{{ two ? 'check' : 'close' }}
                    </v-icon>
                  </template>

                  <template v-else>
                    {{ two }}
                  </template>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>

        <v-col
          cols="12"
          md="5"
        >
          <v-card
            elevation="16"
            class="mb-12"
          >
            <base-img
              max-width="100%"
              src="https://cdn.vuetifyjs.com/images/themes/daedal/daedal-hero.png"
            />
          </v-card>

          <div class="text-center">
            <base-btn
              :tile="false"
              color="primary"
              href="https://store.vuetifyjs.com/product/daedal-responsive-multi-purpose-theme-pro?ref=vtyd-pro-page-features"
              rounded
            >
              Buy Pro Now

              <v-icon right>
                mdi-rocket
              </v-icon>
            </base-btn>
          </div>
        </v-col>
      </v-row>
    </v-container> -->
  </base-section>
</template>

<script>
  export default {
    name: 'SectionProChart',

    data: () => ({
      // imagen: require('@/assets/about.jpg'),
      items: [
        {
          image: 'jobs/estacion.jpg',
          title: 'Estación Elec.',
          slug: 'estacion',
        },
        {
          image: 'jobs/clima.jpg',
          title: 'Climatización',
          slug: 'climatizacion',
        },
        {
          image: 'jobs/contraincendios.jpg',
          title: 'Contraincendios',
          slug: 'contraincendios',
        },
        {
          image: 'jobs/cuadro.jpg',
          title: 'Cuadro Elec.',
          slug: 'cuadro-electrico',
        },
        {
          image: 'jobs/fonta.jpg',
          title: 'Fontanería',
          slug: 'fontaneria',
        },
        {
          image: 'jobs/galisur.jpg',
          title: 'Galisur',
          slug: 'galisur',
        },
        {
          image: 'jobs/oficina.jpg',
          title: 'Oficinas',
          slug: 'oficinas',
        },
        {
          image: 'jobs/renault.jpg',
          title: 'Renault',
          slug: 'renault',
        },
        {
          image: 'jobs/sabadell.jpg',
          title: 'Banco Sabadell',
          slug: 'banco-sabadell',
        },
        {
          image: 'jobs/oficina_1.jpg',
          title: 'Oficinas',
          slug: 'oficinas-1',
        },
        {
          image: 'jobs/data.jpg',
          title: 'Red Datos',
          slug: 'red-datos',
        },
      ],
    }),
  }
</script>
